import { render, staticRenderFns } from "./AssetCategoryPicker.vue?vue&type=template&id=64bef904&"
import script from "./AssetCategoryPicker.vue?vue&type=script&lang=js&"
export * from "./AssetCategoryPicker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports